export const GOALS_GQL_TYPE = 'JiraGoalsField';
